'use client';
import React, { useState, useEffect } from 'react';
import { db, storage } from '../../../firebaseConfig';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import {
  ref as firebaseRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { getAuth } from 'firebase/auth';

export default function AdminStaff() {
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [facebook, setFacebook] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [staffList, setStaffList] = useState([]);

  useEffect(() => {
    const fetchStaff = async () => {
      const snapshot = await getDocs(collection(db, 'teamData'));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setStaffList(data);
    };
    fetchStaff();
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!name || !designation || !imageFile) {
      alert('Please fill out all required fields.');
      return;
    }

    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      alert('You must be logged in to upload staff members.');
      return;
    }

    try {
      const imageRef = firebaseRef(
        storage,
        `staff/${Date.now()}-${imageFile.name}`
      );
      await uploadBytes(imageRef, imageFile);
      const imgUrl = await getDownloadURL(imageRef);

      const docRef = await addDoc(collection(db, 'teamData'), {
        name,
        designation,
        imgUrl,
        social: {
          facebook,
          linkedin,
        },
      });

      setStaffList((prev) => [
        ...prev,
        {
          id: docRef.id,
          name,
          designation,
          imgUrl,
          social: { facebook, linkedin },
        },
      ]);

      // Reset form
      setName('');
      setDesignation('');
      setImageFile(null);
      setFacebook('');
      setLinkedin('');
    } catch (err) {
      console.error(err);
      alert('Upload failed. Are you logged in and have permission?');
    }
  };

  const handleDelete = async (staff) => {
    if (!window.confirm(`Delete ${staff.name}?`)) return;

    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      alert('You must be logged in to delete staff members.');
      return;
    }

    try {
      const imageRef = firebaseRef(storage, staff.imgUrl);
      await deleteObject(imageRef);
      await deleteDoc(doc(db, 'teamData', staff.id));

      setStaffList((prev) => prev.filter((item) => item.id !== staff.id));
    } catch (err) {
      console.error(err);
      alert('Failed to delete staff member.');
    }
  };

  return (
    <div className='container py-5'>
      <h1 className='h3 mb-4 text-center fw-bold'>Add Staff Member</h1>

      <form
        onSubmit={handleUpload}
        className='mx-auto'
        style={{ maxWidth: '600px' }}
      >
        <div className='mb-3'>
          <input
            type='text'
            placeholder='Name'
            className='form-control'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className='mb-3'>
          <input
            type='text'
            placeholder='Designation'
            className='form-control'
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
          />
        </div>
        <div className='mb-3'>
          <input
            type='file'
            accept='image/*'
            className='form-control'
            onChange={(e) => setImageFile(e.target.files[0])}
          />
        </div>
        <div className='mb-3'>
          <input
            type='url'
            placeholder='Facebook URL'
            className='form-control'
            value={facebook}
            onChange={(e) => setFacebook(e.target.value)}
          />
        </div>
        <div className='mb-4'>
          <input
            type='url'
            placeholder='LinkedIn URL'
            className='form-control'
            value={linkedin}
            onChange={(e) => setLinkedin(e.target.value)}
          />
        </div>
        <div className='d-grid'>
          <button type='submit' className='btn btn-primary'>
            Upload
          </button>
        </div>
      </form>

      <hr className='my-5' />

      <h2 className='h4 mb-4'>Current Staff</h2>
      <ul className='list-unstyled'>
        {staffList.map((staff) => (
          <li
            key={staff.id}
            className='d-flex align-items-center justify-content-between bg-light p-3 rounded mb-3'
          >
            <div className='d-flex align-items-center gap-3'>
              <img
                src={staff.imgUrl}
                alt={staff.name}
                className='rounded'
                style={{ width: '64px', height: '64px', objectFit: 'cover' }}
              />
              <div>
                <p className='mb-0 fw-semibold'>{staff.name}</p>
                <p className='mb-0 text-muted small'>{staff.designation}</p>
              </div>
            </div>
            <button
              className='btn btn-link text-danger p-0'
              onClick={() => handleDelete(staff)}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
